import { viewerStrings } from '../copy/strings.js';
import { hasText, optionalText } from '../copy/text.js';
import type { ReactNode } from 'react';
import type { Theme } from '../themes/catalog.js';
import type { FieldState } from '../state/field-state.js';
import { FieldsDialog } from './FieldsDialog.js';
import './workspace-layout.css';

/** The selected lab's four layout families, independent of renderer and query state. */
export function WorkspaceLayout({
  theme,
  section,
  fields,
  navigate,
  children,
}: {
  theme: Theme;
  section: 'records' | 'charts';
  fields: FieldState;
  navigate: (section: 'records' | 'charts') => void;
  children: ReactNode;
}) {
  return (
    <section
      data-copy-navigation={
        hasText(theme.name) ||
        hasText(viewerStrings.webComponentsWorkspaceLayout.records) ||
        hasText(viewerStrings.webComponentsWorkspaceLayout.charts) ||
        hasText(viewerStrings.webComponentsFieldsDialog.fields)
          ? undefined
          : 'empty'
      }
      className={`workspace-shell layout-${theme.layout} ${section === 'records' ? 'record-surface' : 'chart-surface'}`}
    >
      <nav
        className="workspace-navigation"
        data-copy-group
        aria-label={optionalText(viewerStrings.webComponentsWorkspaceLayout.workspace)}
      >
        {hasText(theme.name) ? <span className="workspace-name">{theme.name}</span> : null}
        {hasText(viewerStrings.webComponentsWorkspaceLayout.records) ? (
          <a
            href="#records"
            aria-current={section === 'records' ? 'page' : undefined}
            onClick={(event) => {
              event.preventDefault();
              navigate('records');
            }}
          >
            {viewerStrings.webComponentsWorkspaceLayout.records}
          </a>
        ) : null}
        {hasText(viewerStrings.webComponentsWorkspaceLayout.charts) ? (
          <a
            href="#charts"
            aria-current={section === 'charts' ? 'page' : undefined}
            onClick={(event) => {
              event.preventDefault();
              navigate('charts');
            }}
          >
            {viewerStrings.webComponentsWorkspaceLayout.charts}
          </a>
        ) : null}
        {section === 'charts' && (
          <div className="lab-field-chooser" data-copy-group>
            <FieldsDialog state={fields} />
          </div>
        )}
      </nav>
      <div className="design-content">{children}</div>
    </section>
  );
}
